"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeriodNotFoundException_1 = __importDefault(require("../Exception/PeriodNotFoundException"));
const KEY = "TRAINING.EXERCISE_TO_IMAGES";
class Training {
    constructor(cache, trainingCache, trainingApi, dateTimeBridge, fetch, logger) {
        this.getExercisePhoto = async (exerciseId) => {
            const imageLink = await this.getFromImagesMap(exerciseId);
            if (imageLink === null) {
                return null;
            }
            try {
                return (await this.fetch.fetch(imageLink, {}, false, null));
            }
            catch (e) {
                if (e instanceof Error) {
                    this.logger.error(e);
                }
                return null;
            }
        };
        this.getDate = async (customerId, date, unit) => {
            this.logger.log(`Requesting for Training date ${date}`);
            const sysDate = this.dateTimeBridge.systemDate(date);
            try {
                const training = await this.trainingCache.getDay(sysDate, customerId, async () => {
                    return await this.trainingApi.getDate(customerId, sysDate, unit);
                });
                // should we really wait for it?
                await this.updateImagesMap(training.training && training.training.exercises);
                return training;
            }
            catch (e) {
                if (e instanceof PeriodNotFoundException_1.default) {
                    return null;
                }
                throw e;
            }
        };
        this.mapUserDateFormat = (day) => {
            const [date] = this.dateTimeBridge.userDate(day.date).split("T");
            return {
                ...day,
                date,
            };
        };
        this.getRange = async (userId, dateRange) => {
            const sysRange = this.dateTimeBridge.systemRange(dateRange);
            try {
                const { days } = await this.trainingCache.getRange(sysRange, userId, () => this.trainingApi.getRange(userId, sysRange));
                const trainingsPerWeek = await this.trainingCache.getTrainingsPerWeek(userId, sysRange.to, () => this.trainingApi.getTrainingsPerWeek(userId, sysRange.to));
                return {
                    days: days.filter((day) => !!day).map(this.mapUserDateFormat),
                    trainingsPerWeek,
                };
            }
            catch (e) {
                if (e instanceof PeriodNotFoundException_1.default) {
                    return {
                        days: [],
                        trainingsPerWeek: 0,
                    };
                }
                throw e;
            }
        };
        this.updateImagesMap = async (exercises) => {
            if (!exercises || exercises.length === 0) {
                return;
            }
            const map = await this.cache
                .getObject(KEY)
                .withDefault({})
                .asPromise();
            exercises.forEach((internalExercise) => {
                map[internalExercise.id] = internalExercise.image;
            });
            // TODO: (nice to have) check if change were made
            await this.cache.setObject(KEY, map);
        };
        this.getFromImagesMap = async (exerciseId) => {
            const map = await this.cache
                .getObject(KEY)
                .withDefault({})
                .asPromise();
            return map[exerciseId] || null;
        };
        this.cache = cache;
        this.trainingCache = trainingCache;
        this.trainingApi = trainingApi;
        this.dateTimeBridge = dateTimeBridge;
        this.fetch = fetch;
        this.logger = logger;
    }
}
exports.default = Training;
//# sourceMappingURL=Training.js.map